// extracted by mini-css-extract-plugin
export default {"bulletPointsDiv":"SectionComponent_bulletPointsDiv__Bv+Sg"};